import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App.tsx';
import './theme/styles.css';
import './theme/theme.ts';
import { initNativeBeforeRender } from './native/init.ts';

await initNativeBeforeRender();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
